import type { ActionPropertiesHash, ActionPropertyValueFragment } from '$/shared/typesProxy';

export const actionPropertiesHashFromArray = (
  properties: ActionPropertyValueFragment[]
): ActionPropertiesHash => {
  const propsHash: ActionPropertiesHash = {};
  if (properties.length > 0) {
    properties.map((p) => {
      if (p?.property) {
        propsHash[p.property] = p;
      }
    }, {});
  }
  return propsHash;
};
